import { showDeleteFileDialog } from '../../../../ui/features/mission-files/components/dialogs/showDeleteFileDialog';
import { useMissionFileActions } from '../../../../ui/features/mission-files/hooks/useMissionFileActions';
import { useMissionsTranslation } from '../../../../ui/hooks';
import { fileManagerRowMenuItemsIds } from '@juvare/document-library/ui/hooks';
import React from 'react';
export const useMissionFileMenuItems = () => {
    const { t } = useMissionsTranslation();
    const { deleteFile } = useMissionFileActions();
    const createMenuItems = React.useCallback(({ fileId, fileName, permissions, menuItems: defaultMenuItems, reload }) => {
        const hasModifyPermission = permissions.includes('modify');
        const unnecessaryMenuItems = [fileManagerRowMenuItemsIds.archive, fileManagerRowMenuItemsIds.move];
        const menuItems = [...defaultMenuItems];
        if (hasModifyPermission) {
            menuItems.push({
                label: t('common.delete'),
                onClick: () => {
                    showDeleteFileDialog({ t, fileName, onConfirm: () => deleteFile(fileId, reload) });
                },
                id: 'delete-file',
                'data-test': 'menu-item-delete-file',
            });
        }
        return menuItems.filter((item) => !unnecessaryMenuItems.includes(item.id));
    }, [deleteFile, t]);
    const getRowMenuItems = React.useCallback((params) => {
        const { row, menuItems, reload } = params;
        return createMenuItems({
            fileId: row.id,
            fileName: row.columns.name,
            permissions: row.permissions,
            menuItems,
            reload,
        });
    }, [createMenuItems]);
    const getSlideoutMenuItems = React.useCallback((params) => {
        const { file, menuItems, reload } = params;
        return createMenuItems({
            fileId: file.id,
            fileName: file.columns.name,
            permissions: file.permissions,
            menuItems,
            reload,
        });
    }, [createMenuItems]);
    return { getRowMenuItems, getSlideoutMenuItems };
};
